
import { Component, Vue, Ref } from "vue-property-decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import { Table } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { formDownload } from "@common/src/utils/tools";
const common_warranty = namespace("common_warranty");
const base = namespace("base");
const management = namespace("management");
import t from "@common/src/i18n/t";
import AuditDialog from "./components/audit-dialog.vue";

@InjectFunction("emptyToLine", "appCode", "permitApp")
@Component({ components: { AuditDialog } })
@Table("loadListData", { pageSize: 20 })
export default class WarrantyClaims extends Vue {
  @common_warranty.Action queryWarrantyClaimsList;
  @common_warranty.Action restSendEmail;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @management.Action queryCountryInfoList;

  @Ref("AuditDialog") AuditDialog;

  dayjs = dayjs;
  recordList = [];
  statusList = [];
  autoAuditList = [];
  searchForm: any = {};
  storeList: any = [];
  get searchList() {
    return [
      {
        label: t("v216_g.country"),
        type: "select",
        value: "",
        selectList: this.countryList,
        prop: "countryCode"
      },
      {
        label: t("v3_7_6.apply-for-a-store"),
        type: "select-search",
        value: "",
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore
      },
      {
        label: t("v3_7_6.application-time"),
        type: "daterange",
        value: "",
        prop: "commitTime",
        valueDistribute: ["commitTimeBegin", "commitTimeEnd"]
      },
      {
        label: t("v3_6_0.tire-no"),
        type: "input",
        value: "",
        prop: "tireNo"
      },
      {
        label: t("v3_7_6.tire-brand"),
        type: "select",
        selectList: this.tireBrandList,
        value: "",
        prop: "brand"
      },
      {
        label: t("v3_8_0.tire-type"),
        type: "select",
        selectList: this.tireTypeList,
        value: "",
        prop: "tireType"
      },
      {
        label: t("v3_6_0.plate-no"),
        type: "input",
        value: "",
        prop: "plateCode"
      },
      {
        label: t("v3_7_6.approval-result"),
        type: "select",
        selectList: this.statusList,
        value: "",
        prop: "applyStatus"
      },
      {
        label: t("v3_8_0.claim-type"),
        type: "select",
        selectList: this.claimTypeList,
        value: "",
        prop: "claimType"
      },
      {
        label: t("v3_8_0.cause-of-failure"),
        type: "select",
        selectList: this.faultReasonList,
        value: "",
        prop: "claimFaultReason"
      },
      {
        label: t("v3_8_0.quality-claim"),
        type: "select",
        selectList: [
          { label: t("base.yes"), value: "1" },
          { label: t("base.no"), value: "0" }
        ],
        value: "",
        prop: "qualityClaim"
      },
      {
        label: t("v3_7_6.automatic-approval"),
        type: "select",
        selectList: this.autoAuditList,
        value: "",
        prop: "autoAudit"
      }
    ];
  }
  countryList: any = [];
  tireBrandList = [];
  tireTypeList = [
    { label: "PCR", value: "PCR" },
    { label: "TBR", value: "TBR" }
  ];
  faultReasonList = [];
  claimTypeList = [];
  created() {
    this.getDictionaryList("warranty_claim_apply_status").then(data => {
      this.statusList = data;
    });
    this.getDictionaryList("warranty_claim_type").then(data => {
      this.claimTypeList = data;
    });
    this.getDictionaryList("claim_fault_reason_type").then(data => {
      this.faultReasonList = data;
    });
    this.getDictionaryList("warranty_claim_apply_auto_audit").then(data => {
      this.autoAuditList = data;
    });
    this.getDictionaryList("tire_brand").then(data => {
      this.tireBrandList = data;
    });

    this.queryCountryInfoList({
      pageSize: 999
    }).then(data => {
      this.countryList = (data.data?.list || []).map(item => {
        item.label = item.countryName;
        item.value = item.countryCode;
        return item;
      });
    });
    this.searchStore();
    this.loadListData();
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  async sendEmail(warrantyCardNo) {
    await this.restSendEmail({
      warrantyCardNo
    });
    this.$message.success(t("v3_6_0.sent-success") as string);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryWarrantyClaimsList({
      ...this.searchForm,
      // orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.recordList = data.data.list;
      return data;
    });
  }
  preview(index) {
    const imageRef: any = this.$refs[`previewImg${index}`][0];
    if (imageRef) {
      imageRef.clickHandler();
    }
  }
  previewMileageImg() {
    (this.$refs.previewMileageImg as any).clickHandler();
  }
  handleExportData() {
    const pathMap = {
      "speedbiz-operation": "/op/warranty/claimApply/query/download"
    };
    formDownload(`${window.API_URL}${pathMap[this.appCode]}`, this.searchForm);
  }
  handleShowAuditDialog(row) {
    this.AuditDialog.open(row.applyNo);
  }
  handleToDetail(row) {
    window.open(this.$router.resolve(`/warranty/claims-detail/${row.applyNo}`).href);
  }
}
